import { PaymentStatus as PaymentStatusApi } from '@vendasta/billing';

export enum PaymentStatus {
  Unset = 'UNSET',
  Failed = 'FAILED',
  Succeeded = 'SUCCEEDED',
}

export function paymentStatusFromApi(psApi: PaymentStatusApi | undefined): PaymentStatus {
  switch (psApi) {
    case PaymentStatusApi.PAYMENT_STATUS_FAILED:
      return PaymentStatus.Failed;
    case PaymentStatusApi.PAYMENT_STATUS_SUCCEEDED:
      return PaymentStatus.Succeeded;
  }
  return PaymentStatus.Unset;
}
